


export const BasePackageTableStyle = {
  OutBox: {
    borderRadius: '0',
    height: '100%',
    // borderRadius: 'inherit',
    // borderTopLeftRadius: 0,
    // borderTopRightRadius: 0,
  },
  table: {
    borderRadius: '8px',
    width: '100%',
    height: '100%',
    // my: 2,
    // tableLayout: 'auto', // Add this to fix the table layout
  },
  head: {
    background: '#E5EEFA',
    borderRadius: '8px',
    height: '100%',
  },
  headRow: {
    height: '100%',
  },
  headCell: {
    fontWeight: '600',
    height: '100%',
    fontSize: '14px',
    color: '#2B2B2B',
    textWrap: 'nowrap',
    textAlign: 'center',
    // textAlign: 'left',
    padding: '8px', // Add some padding to the header cells
  },
  body: {
    width: '100%',
    height: '100%'
  },
  row: {
    height: '100%'
  },
  cell: {
    height: '100%',
    fontWeight: '500',
    fontSize: '12px',
    color: '#2B2B2B',
    textAlign: 'center',
    // textAlign: 'left',
    padding: '8px', // Add some padding to the cells
    width: 'auto', // Prevent text from wrapping
  },
  isThreeDot: true,
  threeDot: {
    minHeight: '100%',
    height: '100%',
    verticalAlign: 'inherit',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    width: 'auto',
    // width: '25px',
  },
};
